// src/common/device-id.ts
// Portable device ID utility — zero imports, copy to any project sharing localStorage.
// Key 'DEVICE_ID_KEY' is shared across web-listing and Studio; do NOT rename.
const DEVICE_ID_STORAGE_KEY = 'DEVICE_ID_KEY';

function uuidV4(): string {
  if (typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // Fallback for HTTP (non-secure) contexts — crypto.getRandomValues works everywhere
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export function getDeviceId(): string {
  let id = localStorage.getItem(DEVICE_ID_STORAGE_KEY);
  if (!id) {
    id = uuidV4();
    localStorage.setItem(DEVICE_ID_STORAGE_KEY, id);
  }
  return id;
}
